import React from 'react';
import { useTranslation } from 'react-i18next';
import { CellTitle, CellCommon, CellCard } from '@root/components/Cell';
import './index.less';
import useRemoveDevice from '@root/hooks/subscription/useRemoveDevice';
import PageLoading from '@root/components/PageLoading';
import PageLoadError from '@root/components/PageLoadError';
import Empty from '@root/components/Empty';
import SafeAreaInset from '@root/components/SafeAreaInset';

const DetailRemoveDevice = () => {
  const { t } = useTranslation();
  const { detail, loading, getDetail, onRemove } = useRemoveDevice();

  const { devList } = detail;

  if (loading < 1) {
    return <PageLoading />;
  }

  if (loading === 2) {
    return <PageLoadError onTryAgain={getDetail} />;
  }

  return (
    <>
      <div className="adjust-device-card">
        <CellTitle>{t('remove_device_after')}</CellTitle>
        <CellTitle paddingTop={0}>{t('subscript_bind_devices')}</CellTitle>
        {devList?.length ? (
          <CellCard marginTop={0}>
            {devList.map((d) => {
              return (
                <CellCommon inner key={d.deviceId} title={d.deviceName}>
                  {
                    <span
                      className="a-link remove"
                      onClick={() => onRemove(d.deviceId, d.lockStatus)}
                    >
                      {t('remove')}
                    </span>
                  }
                </CellCommon>
              );
            })}
          </CellCard>
        ) : (
          <Empty marginBottom={20}>{t('no_data')}</Empty>
        )}
        <SafeAreaInset />
      </div>
    </>
  );
};

export default DetailRemoveDevice;
